import { RouterModule, Routes } from "@angular/router";
import { NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SharedModule } from "src/app/shared/shared.module";
import { ProductPageComponent } from "./product-page.component";
import { NavTabsComponent } from './nav-tabs/nav-tabs.component';
import { ProductSyncManagerComponent } from "./sync-manager/product-sync-manager.component";
import { ProductSyncApiComponent } from './sync-api/product-sync-api.component';
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { HttpClient } from "@angular/common/http";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
// sync manager -> new name sync creator
const routes: Routes = [
    {
      path: '',
      component: ProductPageComponent
    },
    {
      path: "sync-api",
      component: ProductSyncApiComponent
    },
    {
      path: "sync-creator",
      component: ProductSyncManagerComponent
    },
    {
      path: "creator",
      component: ProductSyncManagerComponent
    },
    {
      path: "designer",
      component: ProductSyncManagerComponent
    },
    {
      path: "backoffice",
      component: ProductSyncManagerComponent
    }
  ];
  
  @NgModule({
    declarations: [
        ProductPageComponent,
        NavTabsComponent,
        ProductSyncManagerComponent,
        ProductSyncApiComponent
    ],
    imports: [
      CommonModule,
      SharedModule,
      RouterModule.forChild(routes),
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: (createTranslateLoader),
          deps: [HttpClient]
        }
      }),
    ],
    exports:[
        ProductPageComponent
    ],
    schemas:[
        NO_ERRORS_SCHEMA
    ]
  })
  export class ProductModule { }
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}